/**
 * Format a stock/quantity number for display.
 * Caps at 2 decimal places to prevent UI bloat (e.g. 32.85179999999999).
 * Display-only — never use to round stored or computed values.
 */
export function formatStock(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return "0";
  const num = typeof n === "number" ? n : Number(n);
  if (!Number.isFinite(num)) return "0";
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/**
 * El mismo tope de 2 decimales para SALIDAS DE DATOS (CSV), donde el número lo lee
 * una hoja de cálculo y no una persona: punto decimal y sin separador de millares.
 * formatStock() aquí escribiría «24.500» para 24500 y Excel lo leería como 24,5.
 */
export function stockValue(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return "";
  const num = typeof n === "number" ? n : Number(n);
  if (!Number.isFinite(num)) return "";
  return String(Math.round(num * 100) / 100);
}
